import { devLog } from '../../../../core/utils/logging.js';

/**
 * Collapses the deprecated per-threshold `showIndicator` flags into a single
 * chart-level "show threshold indicators" value, shared by the standalone
 * `MeterBarChart` and the DataTable `meterbar` column.
 *
 * - all defined flags `true` → `true` (show all indicators)
 * - all defined flags `false` → `false` (hide all indicators)
 * - no flag defined → `undefined` (no legacy config; defer to the default)
 * - a mix of `true`/`false` (indeterminate) can't map to a single flag, so we
 *   warn the developer with `mixedValuesWarning` and defer to the default.
 *
 * The old per-threshold `showIndicator` defaulted to `false`, so an unset flag
 * is treated as `false` when collapsing.
 * @internal
 */
export function collapseThresholdShowIndicators(
  showIndicators: Array<boolean | undefined>,
  mixedValuesWarning: string,
): boolean | undefined {
  const usesLegacyConfig = showIndicators.some((flag) => flag !== undefined);
  if (!usesLegacyConfig) {
    return undefined;
  }

  const resolvedFlags = showIndicators.map((flag) => flag ?? false);
  if (resolvedFlags.every((flag) => flag === true)) {
    return true;
  }
  if (resolvedFlags.every((flag) => flag === false)) {
    return false;
  }

  devLog(mixedValuesWarning);
  return undefined;
}
